import { COLORS } from 'shared/constants/COLORS';
const { PRIMARY_CALENDAR_SESSION, DARK_GREEN_CALENDAR_CALLBACK } = COLORS;

export const convertSessionToMarkData = (value: { session_date: Date; session_type: string }) => {
  let color = '';
  switch (value.session_type.toLocaleLowerCase()) {
    case 'auditions':
      color = PRIMARY_CALENDAR_SESSION;
      break;
    case 'callback':
      color = DARK_GREEN_CALENDAR_CALLBACK;
      break;
    default:
      break;
  }

  return {
    date: value.session_date,
    color,
  };
};
